import React from "react";
import { Store } from "lucide-react";

const CATEGORIES = ["Marketing", "Coaching", "SaaS", "E-commerce", "Education", "Finance", "Health", "Other"];

export default function PublishMarketplaceModal({ form, setForm, publishing, onCancel, onSubmit }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/50">
      <div className="card-brutal !p-8 max-w-lg w-full bg-white" data-testid="publish-modal">
        <div className="flex items-center gap-2 mb-2">
          <Store size={18} className="text-[#FF4F00]" />
          <h2 className="font-display font-black text-2xl">Publish to Marketplace</h2>
        </div>
        <p className="text-sm text-zinc-600 mb-5">
          Help other marketers ship faster. Your template appears in the public Marketplace with author credit, conversion stats, and clone counts.
        </p>
        <div className="space-y-3">
          <Field
            label="Title"
            value={form.title}
            onChange={(v) => setForm({ ...form, title: v })}
            testid="pub-title"
          />
          <div>
            <label className="label-cap block mb-1">Description</label>
            <textarea
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
              rows={3}
              className="input-brutal"
              data-testid="pub-desc"
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="label-cap block mb-1">Category</label>
              <select
                value={form.category}
                onChange={(e) => setForm({ ...form, category: e.target.value })}
                className="input-brutal"
                data-testid="pub-category"
              >
                {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <Field
              label="Tags (comma)"
              value={form.tags}
              onChange={(v) => setForm({ ...form, tags: v })}
              placeholder="seo, b2b, saas"
              testid="pub-tags"
            />
          </div>
        </div>
        <div className="flex gap-3 justify-end mt-6">
          <button onClick={onCancel} className="btn-brutal-outline" data-testid="pub-cancel">Cancel</button>
          <button
            onClick={onSubmit}
            disabled={publishing || !form.title.trim()}
            className="btn-brutal"
            data-testid="pub-submit"
          >
            {publishing ? "Publishing…" : "Publish Now"}
          </button>
        </div>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, placeholder, testid }) {
  return (
    <div>
      <label className="label-cap block mb-1">{label}</label>
      <input
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="input-brutal"
        data-testid={testid}
      />
    </div>
  );
}
